import { PdfFileIcon } from "@/assets/images/svgIcons/medias/pdfFileIcon"
import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"

export function PdfThumbnail({
  displayDetailedEvents,
  className,
}: {
  displayDetailedEvents: boolean
  className?: string
}) {
  return (
    <div
      className={cn(
        "flex h-full w-full items-center justify-center bg-linear-to-b from-neutral-600 to-neutral-700",
        className,
      )}
    >
      <PdfFileIcon
        color="currentColor"
        className="size-2xl center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-neutral-200"
        width={24}
        height={24}
        strokeWidth={8}
      />
      {displayDetailedEvents ? (
        <Text fontStyle="DM" className="absolute right-0 bottom-0 pr-2 text-[3vw] text-neutral-500">
          PDF
        </Text>
      ) : null}
    </div>
  )
}
